import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';
import { type ReactElement } from 'react';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import formatCloseRelative from '../../Util/formatCloseRelative';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import { type TrafficCamera as TrafficCameraProperties } from '../Sources/TrafficCameraSource';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function TrafficCamera(properties: TrafficCameraProperties, layerOptions: ClusteredMarkerLayerOptions): ReactElement {
    const photoTime = properties.photoTime ? parseISO(properties.photoTime) : null;
    return (
        <PopupTemplateWrapper iconId={layerOptions.defaultIconId} title={layerOptions.name}>
            <div className="pop camera-popup d-flex flex-column">
                <h3>{properties.name}</h3>

                <a className="mb-auto" href={properties.url}>
                    <img className="traffic-camera-thumb" src={properties.imageUrl} alt={properties.name} />
                </a>

                <div className="d-flex justify-content-between mt-1">
                    <a href={properties.url}>Visa mer &raquo;</a>
                    <div id="popup-favorite-toggler" />
                </div>
                {(photoTime || properties.source) && (
                    <dl className="popup-details">
                        {photoTime && (
                            <>
                                <dt>Bilden tagen:</dt>
                                <dd>
                                    <TimeElement date={photoTime}>
                                        {`${capitalizeFirstLetter(formatCloseRelative(photoTime, 'noTime'))} ${format(photoTime, 'HH.mm')}`}
                                    </TimeElement>
                                </dd>
                            </>
                        )}
                        {properties.source && (
                            <>
                                <dt>Källa:</dt>
                                <dd>{properties.source}</dd>
                            </>
                        )}
                    </dl>
                )}
            </div>
        </PopupTemplateWrapper>
    );
}
